/* tslint:disable */
/* eslint-disable */
/**
 * Locations Api Documentation
 * Locations Microservice is a High Availability API built to search for locations. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export * from "./api";
export * from "./configuration";

